import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  @Input() isLoading = false;
  private sub?: Subscription;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {
    // Nếu không có @Input, subscribe từ LoadingService
    if (this.isLoading === false) {
      this.sub = this.loadingService.loading$.subscribe(
        (value) => (this.isLoading = value)
      );
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
